import { z } from "zod";

import { launchDarklyInfoSchema } from "./launch-darkly-info";

const cubeRequestParametersSchema = z.object({
	minimumDimension1: z.number(),
	maximumDimension1: z.number(),
	incrementDimension1By: z.number(),
	minimumDimension2: z.number(),
	maximumDimension2: z.number(),
	incrementDimension2By: z.number(),
	minimumDimension3: z.number(),
	maximumDimension3: z.number(),
	incrementDimension3By: z.number(),
	maxResults: z.number(),
	orderBy: z.string(),
	cutoffTimeMs: z.number(),
	shrinkwrap: z.boolean(),
	shrinkwrapMinDim: z.number(),
	ignorePartialSolutions: z.boolean(),
});

const boxListParameterSchema = z.object({
	alias: z.string(),
	dimension1: z.number(),
	dimension2: z.number(),
	dimension3: z.number(),
});

export const cubeOptionsSchema = z.object({
	launchDarkly: launchDarklyInfoSchema.nullish(),
	useBoxList: z.boolean(),
	cubeRequestParameters: cubeRequestParametersSchema.optional(),
	boxListParameters: z.array(boxListParameterSchema).optional(),
	maximumResults: z.number(),
});
